(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import { Radio as MuiRadio, RadioGroup as MuiRadioGroup, FormControlLabel, FormControl, FormLabel } from '@material-ui/core';
import PropTypes from 'prop-types';

var RadioGroup = function RadioGroup(props) {
  var options = props.options,
      value = props.value,
      onChange = props.onChange,
      name = props.name,
      label = props.label,
      color = props.color,
      direction = props.direction;
  var handleChange = onChange;
  return React.createElement(FormControl, {
    component: "fieldset"
  }, label ? React.createElement(FormLabel, {
    component: "legend"
  }, label) : null, React.createElement(MuiRadioGroup, {
    row: direction === 'row',
    "aria-label": name,
    name: name,
    value: value,
    onChange: handleChange
  }, options.map(function (option) {
    return React.createElement(FormControlLabel, {
      key: option.value,
      value: option.value,
      control: React.createElement(MuiRadio, {
        color: color
      }),
      label: option.text,
      disabled: Boolean(option.disabled)
    });
  })));
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool
  })),
  value: PropTypes.string,
  onChange: PropTypes.func,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  direction: PropTypes.oneOf(['row', 'column'])
};
RadioGroup.defaultProps = {
  options: [],
  onChange: function onChange() {
    return console.warn('No onChange function is provided');
  },
  color: 'default',
  direction: 'column'
};
var _default = RadioGroup;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RadioGroup, "RadioGroup", "/home/vsts/work/1/s/src/components/inputs/RadioGroup.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/RadioGroup.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();